import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { DownloadKitButtonSelectorDataProviderFactory } from '../factory/DownloadKitButtonSelectorDataProviderFactory';
import { DownloadKitButtonSelectorWebComponent } from '../component/DownloadKitButtonSelectorWebComponent';
import { DownloadKitButtonSelectorGzDataProvider } from '../dataProvider/DownloadKitButtonSelectorGzDataProvider';
import { CheckAccessToPackageResponse, DownloadResponse } from '../types/types';
import { DownloadTypes, KitStatuses } from '../constants';

export class DownloadKitButtonSelectorRepository extends BaseWebComponentRepository {
  public component: DownloadKitButtonSelectorWebComponent;
  public dataProviderFactory: DownloadKitButtonSelectorDataProviderFactory;
  public dataProvider: DownloadKitButtonSelectorGzDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new DownloadKitButtonSelectorDataProviderFactory(),
    });
  }

  /**
   *
   * @param kitsIds
   * @param oemKitId
   */
  public async getDownloadTypeStatuses(
    kitsIds: Array<number>,
    oemKitId: number
  ): Promise<{ [key in DownloadTypes]: KitStatuses }> {
    const response = await this.dataProvider.getDownloadTypeStatuses(kitsIds, oemKitId);
    return response.downloadTypeStatuses;
  }

  public async getPackageCompanyRingVersions(packageCompanyId: string): Promise<any> {
    return await this.dataProvider.getPackageCompanyRingVersions(packageCompanyId);
  }

  /**
   * Start publish and return
   * @param packageId
   * @param downloadType
   */
  public async download(packageId: string, downloadType: number): Promise<DownloadResponse> {
    return this.dataProvider.download(packageId, downloadType);
  }

  /**
   * Check access to package and if is not publish will trigger the publish
   * @param packageId
   * @param downloadType
   */
  public async checkAccessToPackage(packageId: string, downloadType: number): Promise<CheckAccessToPackageResponse> {
    return this.dataProvider.checkAccessToPackage(packageId, downloadType);
  }
}
